import { Button, Typography } from '@mui/material';
import { ReactComponent as VoiceIcon } from 'assets/img/icon-call.svg';
import { ReactComponent as DataIcon } from 'assets/img/icon-data.svg';
import ROAMING_PRODUCT_LABELS from 'components/RoamingProduct/RoamingProduct.labels';
import styles from 'components/RoamingProduct/RoamingProduct.module.scss';
import useLocalizedData from 'hooks/useLocalizedData';
import { buildDisplayPrice } from './RoamingProduct.utils';

const RoamingProduct = ({ plan, hideFromLabel = false, redirectUrl }) => {
  const [labels] = useLocalizedData(ROAMING_PRODUCT_LABELS);
  const displayPrice = buildDisplayPrice(plan);

  return (
    <div className={styles.plan}>
      <div className="w-100">
        <Typography component="div" variant="h5" className="pb-3">
          {plan?.title}
        </Typography>
        <div className={styles.characteristicContainer}>
          {Array.isArray(plan?.characteristics) &&
            plan.characteristics.map((characteristic, id) => (
              <div className={styles.characteristic} key={id}>
                {characteristic?.type === 'data' && <DataIcon className={styles.characteristicIcon} />}
                {characteristic?.type === 'voice' && <VoiceIcon className={styles.characteristicIcon} />}
                <div>
                  <Typography component="div" variant="h6">
                    {characteristic?.title}
                  </Typography>
                  <Typography component="div" variant="body1">
                    {characteristic?.desc}
                  </Typography>
                </div>
              </div>
            ))}
        </div>
        <div className={styles.priceContainer}>
          {displayPrice ? (
            <>
              {!hideFromLabel && (
                <Typography component="div" variant="caption">
                  {labels?.['from']}
                </Typography>
              )}
              <span className={styles.price}>{displayPrice}</span>
              {plan?.price?.type && labels?.priceSuffix?.[plan.price.type] && (
                <Typography component="span" variant="caption">
                  {labels.priceSuffix[plan.price.type]}
                </Typography>
              )}
            </>
          ) : (
            <span className={styles.price}>{labels?.['free']}</span>
          )}
        </div>
      </div>
      <div className="w-100">
        <div className={styles.actionContainer}>
          <Typography component="div" variant="caption" className="pb-1">
            {labels?.['activateOn']}
          </Typography>
          <Button
            disableRipple
            disableFocusRipple
            disableTouchRipple
            disableElevation
            type="button"
            variant="contained"
            className="rounded-5 px-4 py-2 w-100"
            sx={{
              ':focus': { outline: 'none' },
              ':focus-visible': { outline: '2px solid black', outlineOffset: '3px' },
            }}
            href={redirectUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {labels?.['buttonLabel']}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RoamingProduct;
